module.exports = __webpack_public_path__ + "img/number_2.b0188038.png";